import { MODULES } from "#constants/modules";
import Form from "./pages/Form";
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import MyEvaluations from "./pages/MyEvaluations";
import MyTeam from "./pages/MyTeam";
import PERMISOS from "#constants/perfiles";
import Diversity2Icon from '@mui/icons-material/Diversity2';
import SchoolIcon from '@mui/icons-material/School';

export const URLS = {
  "Evaluación de Desempeño": [
    {
      module: MODULES.COLABORADOR,
      path: "performance_evaluation/my_evaluations",
      element: <MyEvaluations />,
      title: "Mis Evaluaciones",
      icon: SchoolIcon ,
      permissions: [],
      textDivider: "annul_plan",
      subPath: "collaboratorId",
    },
    
    {
      module: MODULES.COLABORADOR,
      path: "performance_evaluation/my_team",
      element: <MyTeam />,
      title: "Mi Equipo",
      icon: Diversity2Icon ,
      permissions: [],
      textDivider: "annul_plan",
    },

    
  ],
};
